import _ from 'lodash'

/**
 * Maps keys of obj as specified by keyMap.
 * Drops keys not specified in keymap
 * If keyMap specifies a key that obj doesn't have, it's omitted
 */
export function mapKeysByObject(obj, keyMap, options) {
  if (options && options.reverse) {
    keyMap = _.invert(keyMap)
  }

  let newObj = {}
  _.forOwn(keyMap, (toKey, fromKey) => {
    if (_.has(obj, fromKey)) {
      _.set(newObj, toKey, _.get(obj, fromKey))
    }
  })
  return newObj
}

export function isContactInfoEmpty(contact) {
  let { firstName, lastName, email } = contact
  return (
    !firstName ||
    firstName === '' ||
    (!lastName || lastName === '') ||
    (!email || email === '')
  )
}

// Gets the Object values
export function getObjVal(val) {
  if (!isEmpty(val) && typeof val === 'string') {
    return val
  } else if (!isEmpty(val) && val instanceof Object) {
    if (val.value instanceof Object) {
      return getObjVal(val.value)
    } else {
      return !isEmpty(val.value) ? val.value : ''
    }
  }
  return !isEmpty(val) ? val : ''
}

export function getBooleanVal(val) {
  if (typeof val === 'string') {
    return getObjVal(val) == 'true'
  } else {
    return getObjVal(val)
  }
}

// Checks whether the given object is empty or not
export function isEmpty(val) {
  if (typeof val === 'string' || val instanceof String) {
    return val.trim().length == 0
  }
  return (
    val === null ||
    val === undefined ||
    (val instanceof Object && Object.keys(val).length == 0)
  )
}

// Gives the RoomClassname for the guest entry section guest-entry page
export function getRoomClassName(roomField, rooms) {
  let room = rooms[getObjVal(roomField)]
  if (room) {
    let className = room.type.toLowerCase() + '-' + room.gender.toLowerCase()
    return className
  }
}

export function getRoomDisplayNameById(roomId, rooms) {
  if (getObjVal(roomId)) {
    let roomObject = rooms[getObjVal(roomId)]
    return getRoomDisplayName(roomObject.type, roomObject.gender)
  } else {
    return ''
  }
}

// Gets the formatted display name
export function getRoomDisplayName(type, gender, roomConfiguration) {
  let ret = roomConfiguration || type
  if (gender === 'male') {
    ret = "Men's " + ret
  } else if (gender === 'female') {
    ret = "Women's " + ret
  }
  return ret
}

export function getRoomDisplayNameForGuestEntry({ room, authenticated }) {
  return authenticated
    ? room.name
    : getRoomDisplayName(room.type, room.gender, room.roomConfiguration)
}

export function getRoomsOptions(selectedRooms, rooms) {
  let addedNames = []
  let roomsList = _.flatMap(selectedRooms, room => {
    if (room.roomId) {
      let roomObject = rooms[getObjVal(room.roomId)]
      if (roomObject) {
        const roomDisplayName = room.displayName
        // Don't display same name more than once in the dropdown
        if (addedNames.indexOf(roomDisplayName) === -1) {
          addedNames.push(roomDisplayName)
          return { value: roomObject.id, label: roomDisplayName }
        }
      }
    }
  })
  roomsList = _.remove(roomsList, undefined)
  roomsList.unshift({ value: '', label: 'Please Select' })
  return roomsList
}

export function getFromCache(fieldName) {
  let field = localStorage.getItem(fieldName)
  if (field && JSON.parse(field) && Object.keys(JSON.parse(field)).length > 0) {
    return JSON.parse(field)
  }
}
// Filters the given array and removes empty string and undefined values
export function filterArray(array) {
  return _.without(_.without(array, ''), undefined)
}

// Validates the array and return true if it is empty
export function isEmptyArray(array) {
  return filterArray(array).length === 0
}

/**
 * This method will return the inner elements from the given map
 * @param map: Input map to search
 * @param nestedEntryName: Nested field name to search
 */
export function getEntriesByKey(map, nestedEntryName) {
  return _.map(map, entry => {
    return entry[nestedEntryName]
  })
}



// WEBPACK FOOTER //
// ./src/utils.js